import api from "./api";

const feeService = {
    getMarketplaceBuyFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getMarketplaceBuyFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getExchangeBuyFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getExchangeBuyFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getExchangeSellFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getExchangeSellFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getDepositFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getDepositFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getWithdrawFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getWithdrawFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
    getTransferOutFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getTransferOutFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Bearer ${jwttoken}` } 
        }),
        
};

export default feeService;